/**
 * Temporary site id used while recording a brand-new site from Contractor 360
 * (Adopted Contractor / All End Users → "+") before Task List creates the real site lead.
 * Chunks stay in IndexedDB under this id until `bindSiteVisitRecordingSiteId` reassigns them.
 */
export const PROVISIONAL_NEW_SITE_RECORDING_ID = -1;

export function isProvisionalSiteVisitRecordingSiteId(siteId: number | null | undefined): boolean {
	return siteId == null || siteId === PROVISIONAL_NEW_SITE_RECORDING_ID || siteId <= 0;
}
